import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type AppCanvasProps = {
  children: ReactNode;
  className?: string;
};

/** Conteúdo autenticado: coluna de telefone no mobile, canvas largo no desktop. */
export const AppCanvas = ({ children, className }: AppCanvasProps) => (
  <div
    className={cn(
      "mx-auto w-full max-w-md px-5 py-6 animate-fade-up md:max-w-5xl md:px-8 md:py-10",
      className,
    )}
  >
    {children}
  </div>
);
